<div class="container-fluid">

  <h4 id="upper">Sous activités ordonnancées</h4>
  <div class="d-flex justify-content-end">

    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Programmes:
          <select type="text" name="searchTerm" class="form-select ms-2" aria-controls="tickets-table"
            [(ngModel)]="selectedProjet" (change)="processSelectedProjet()">
            <option [ngValue]="null">Tous les programmes</option>
            <option *ngFor="let item of projetItems" [ngValue]="item.reference"> {{ item?.libelle}}</option>
          </select>
        </label>
      </div>
    </div>

    <div *ngIf="showFiltre === true" class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Direction:
          <select type="text" name="searchTerm" class="form-select ms-2" aria-controls="tickets-table"
            [(ngModel)]="selectedDirection" (change)="filterDataByDirections()">
            <option [ngValue]="null">Toutes les directions</option>
            <option *ngFor="let item of directionItems" [ngValue]="item.reference"> {{ item?.libelle}}</option>
          </select>
        </label>
      </div>
    </div>

  </div>

  <p-tabView>

    <p-tabPanel header="Non Ordonnancés ({{itemNonOrdonancer ? itemNonOrdonancer.length :0}})">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">
                </div>
              </div>

              <div class="table-responsive mt-3">
                <table class="table table-centered datatable dt-responsive nowrap"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                  <thead class="thead-light  rwd-table">
                    <tr>
                      <th>Code</th>
                      <th>Libellé</th>
                      <th> Montant planifié</th>
                      <th>Total engagé</th>
                      <th>Total Ordonnancé</th>
                      <th>Reste à Ordonnancé</th>
                      <th style="width: 120px;"></th>
                      <th style="width: 120px;"></th>
                    </tr>
                  </thead>
                  <tbody *ngIf="isLoading === false">
                    <tr *ngFor="let item of paginateNonOrdonnancement; let index = index">
                      <td>{{item.code_activite}}</td>
                      <td>{{item.activite}}</td>
                      <td>{{item.total | formatMoney:null }}</td>
                      <td>{{item.total_engage | formatMoney:null }}</td>
                      <td>{{item.total_ordonnance | formatMoney:null}}</td>
                      <td>{{item.total_engage - item.total_ordonnance | formatMoney:null}}</td>
                      <td>
                        <button style="width: 150px;" (click)="openModal(item)" title="Cliquez ici pour voir le détails"
                          class="btn btn-success btn-sm">
                          <i class="mdi mdi-check-all font-size-1"></i> Ordonnancer </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                  <div class="container">
                    <div class="row">
                      <div class="text-center">
                        <h5 id="graycolor">Chargement en cours</h5>
                        <div class="loader4"></div>
                      </div>
                    </div>
                  </div>

                </div>

                <div *ngIf="paginateNonOrdonnancement.length === 0 && isLoading === false"
                  class="d-flex justify-content-center">
                  <div class="container">
                    <div class="row">
                      <div class="text-center">
                        <h5 id="graycolor">Aucune donnée trouvée</h5>
                      </div>
                    </div>
                  </div>

                </div>
                <p-paginator (onPageChange)="onPageChangeNonOrdonnanement($event)" [first]="firstNonOrdonnanceemnt"
                  [rows]="rowsNonOrdonnancement" [totalRecords]="totalRecords2" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
              </div>

            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Ordonnancés ({{items ? items.length : 0}}) ">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">

                </div>

              </div>
              <div class="table-responsive mt-3">
                <table class="table table-centered datatable dt-responsive nowrap"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                  <thead class="thead-light  rwd-table">
                    <tr>
                      <th>Code</th>
                      <th>Libellé</th>
                      <th> Montant planifié</th>
                      <th>Total engagé</th>
                      <th>Total Ordonnancé</th>
                      <th>Reste à Ordonnancé</th>

                      <th style="width: 120px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of paginatedOrdonnancement; let index = index">
                      <td>{{item.code_activite}}</td>
                      <td>{{item.activite}}</td>
                      <td>{{item.total | formatMoney:null}}</td>
                      <td>{{item.total_engage | formatMoney:null}}</td>
                      <td>{{item.total_ordonnance | formatMoney:null}}</td>
                      <td>{{item.total_engage - item.total_ordonnance | formatMoney:null}}</td>

                      <td>



                        <button (click)="openModalHistoriqueOrdonnacement(item)"
                          title="Cliquez ici pour voir le détails" class="btn btn-success btn-sm">
                          <i class="mdi mdi-cancel font-size-18"></i> Détails </button>


                      </td>
                    </tr>

                  </tbody>
                </table>
                <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                  <div class="container">
                    <div class="row">
                      <div class="text-center">
                        <h5 id="graycolor">Chargement en cours</h5>
                        <div class="loader4"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="!paginatedOrdonnancement" class="d-flex justify-content-center">
                  <div class="container">
                    <div class="row">
                      <div class="text-center">
                      </div>
                    </div>
                  </div>
                </div>
                <p-paginator (onPageChange)="onPageChangeOrdonnacnement($event)" [first]="firstOrdonnancement"
                  [rows]="rowsOrdonnancement" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>


  </p-tabView>
</div>




<ng-template #ordonnancementModal let-modal>

  <div class="modal-header">
    <h5 class="modal-title">Ordonnancement</h5>
    <button (click)="modal.dismiss('Close click')" type="button" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form>

        <!-- ligne de montants -->
        <div class="d-flex">

          <div class="form-group col-md-4">
            <label for="name">Total engagé</label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.total_engage" disabled
              name="total_engage" type="number" class="form-control" id="name" placeholder="Total engagé">
          </div> &nbsp;

          <div class="form-group  col-md-4 me-2">
            <label for="name">Total ordonnancé </label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.total_ordonnance" disabled
              name="total_ordonnance" type="number" class="form-control" id="name" placeholder="0 ">

          </div>

          <div class="form-group  col-md-4 me-2">
            <label for="name">Reste</label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.reste" disabled name="reste"
              type="number" class="form-control" id="name" placeholder="0 ">

          </div>
        </div><br>

        <div class="d-flex">

          <div class="form-group  col-md-8 me-2">
            <label for="name">Activité Opérationnelle</label>
            <textarea style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.activite" name="libelle"
              type="text" class="form-control" disabled placeholder="Libellé ">
            </textarea>
          </div>
          <div class="form-group col-md-4 me-2">
            <label for="name">Inputation</label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.amputation_budgetaire"
              name="amputation_budgetaire" type="text" class="form-control" id="name" disabled
              placeholder="amputation_budgetaire">
          </div> &nbsp;


        </div><br>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="email">Ordonnancé le </label>
            <input type="date" [(ngModel)]="sousActiviteItem.date_ordonnance" name="date_ordonnacement"
              class="form-control" id="date" placeholder="">
          </div>

          <div class="form-group  col-md-6">
            <label for="name">Montant à ordonnancer</label>
            <input [(ngModel)]="sousActiviteItem.total_a_ordonnancer" name="montant_a_ordonnancer" type="number"
              class="form-control" id="name" placeholder=" Montant ordonnancé " (ngModelChange)="calculateReste()">

          </div>

        </div>

        <!-- ligne de montants -->
        <div class="d-flex mb-2">
          <div class="form-group col-md-12 me-2">
            <label for="email">Numero mandat</label>
            <input type="text" [(ngModel)]="sousActiviteItem.no_mandat" name="no_mandat" class="form-control" id="date"
              placeholder="">
          </div>
          &nbsp;
        </div>
        <div class="d-flex">
          <div class="form-group col-md-6 me-2">
            <label for="email">Lien Mandat</label>
            <input type="file" (change)="onFileSelected($event)" name="lien" class="form-control">
          </div>&nbsp;

          <div class="form-group col-md-6">
            <label for="email">Observations</label>
            <textarea type="text" name="observations" [(ngModel)]="sousActiviteItem.observations" class="form-control"
              id="observations" placeholder=""> </textarea>
          </div>
        </div><br>


        <div class="text-end">
          <div class="text-end">
            <button (click)="modal.dismiss('Close click')" type="button" class="btn btn-light ms-1"> <i
                class="pi pi-times" style="color: #212529"></i> Annuler</button> &nbsp;
            <button (click)="saveOrdonnancement()" type="submit" class="btn btn-success"> <i class="pi pi-save"
                style="color: white"></i>
              Ordonnancer</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>


<ng-template #ordonnancementModalDetail let-modal>

  <div class="modal-header">
    <h5 class="modal-title">Historique d'ordonnancement</h5>
    <button (click)="modal.dismiss('Close click')" type="button" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">

    <!-- Loader -->
    <div *ngIf="isLoadingOrdonnancement" class="text-center">
      <p>Chargement...</p>
    </div>

    <!-- Table -->
    <div class="table-responsive" *ngIf="!isLoadingOrdonnancement && ordonnancements?.length > 0">
      <table class="table table-bordered table-hover">
        <thead class="table-light">
          <tr>
            <th class="text-center">Date d'ordonnancement</th>
            <th class="text-center">Montant ordonnancé</th>
            <th class="text-center">Numéro mandat</th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of ordonnancements">
            <td class="text-center">
              {{ item.date_ordonnance | date:'dd/MM/yyyy' }}
            </td>
            <td class="text-end">
              {{ item.mt_ordonnance | formatMoney:null }}
            </td>
            <td class="text-center">
              {{ item.no_mandat || '-' }}
            </td>

            <td class="text-center">
              <div class="d-flex justify-content-center align-items-center gap-2">

                <button (click)="cancelOrdonnancement(item)" title="Cliquez ici pour annuler"
                  class="btn btn-success btn-sm d-flex align-items-center">
                  <i class="mdi mdi-cancel me-1"></i> Annuler
                </button>

                <button (click)="exportToDocument(item)" title="Cliquer ici pour télécharger une fiche"
                  class="btn btn-secondary btn-sm d-flex align-items-center">
                  <i class="pi pi-download me-1"></i> Fiche
                </button>

              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Aucun résultat -->
    <div *ngIf="!isLoadingOrdonnancement && ordonnancements?.length === 0" class="text-center">
      <p>Aucun ordonnancement trouvé</p>
    </div>

  </div>

</ng-template>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>
